import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { PPSI } from '@ikea-food-ux/ppsi';
import { getOverviewLabels } from '../../../features/app/overviewLabelSelectors';
import { getProductions } from '../../../features/app/productionSelectors';
import { getStockHierarchy } from '../../../features/app/stockHierarchySelectors';
import { getTemperatureUnits } from '../../../features/app/temperatureUnitSelectors';
import { getTimeUnits } from '../../../features/app/timeUnitSelectors';
import {
  getIngredientEntriesByIds,
  getIngredientEntries
} from '../../../features/IngredientEntryContainer/selectors';
import { getPpiDataForIds } from '../../../features/PpiContainer/selectors';
import { getUtensils } from '../../../features/UtensilContainer/selectors';
import { getLanguage, getConfigs } from '../../../features/app/selectors';
import { stitchPpis } from '../../../utils/ui2pStitchPPI';
import stichPpsi from '../../../utils/ui2pStitchPPSI';
import FormContext from '../../Form/FormContext';

import { sortBy } from 'lodash';
import { getShelfLifeTimeUnitsUnits } from 'features/app/shelfLifeTimeUnitsSelectors';

function getPpiDataIdsFromPpiDetails(ppiDetails = []) {
  return ppiDetails
    .filter(ppiDetail => ppiDetail.ppiEnrichmentDataId)
    .map(ppiDetail => ppiDetail.ppiEnrichmentDataId);
}

const OverviewTabContent = () => {
  const { data } = useContext(FormContext);
  const { ppiDetails, ingredientEntryIds } = data;
  const ppiDataIds = getPpiDataIdsFromPpiDetails(ppiDetails);
  const franchiseType = useSelector(getConfigs).toJS().franchise;
  const ppiDataList = useSelector(getPpiDataForIds(ppiDataIds)).toJS();
  let isNir=franchiseType==="NIR";

  let ingredientEntries =useSelector(
    getIngredientEntriesByIds(ingredientEntryIds)
  ).toJS();
  // let ingredientEntries=
  // isNir && data&&data.referencedIFoodData ?
  // data&&data.referencedIFoodData&&data.referencedIFoodData.referencedIngredientEntities:
  // ingredientEntriesList
  // debugger
  // if (Object.keys(data).includes('referencedIFoodData')) {
  //   const itemCodes = data.referencedIFoodData.referencedIngredientEntities
  //     .sort((a, b) => a.lineId - b.lineId)
  //     .map(a => a.itemCode);
      
  //   ingredientEntries = ingredientEntries.map(s => ({
  //     ...s,
  //     lineId: itemCodes.indexOf(s.itemCode) + 1
  //   }));
  // }
  if (
  data &&
  data.referencedIFoodData &&
  Array.isArray(data.referencedIFoodData.referencedIngredientEntities)
) {
  const referenceItems = data.referencedIFoodData.referencedIngredientEntities
    .sort((a, b) => a.lineId - b.lineId);

  ingredientEntries = ingredientEntries.map(entry => {
    const ref = referenceItems.find(x => x.itemCode === entry.itemCode);

    if (!ref) return entry;

    // merge amount here
    return {
      ...entry,
      lineId: ref.lineId,
      amount: ref.amount ? { ...ref.amount } : entry.amount
    };
  });
}

 
  const language = useSelector(getLanguage);
  const unitSystem = useSelector(getConfigs).toJS().ifoodPPSIUnitSystem;
  const labels = useSelector(getOverviewLabels).toJS();
  const timeUnits = useSelector(getTimeUnits).toJS();
  const temperatureUnits = useSelector(getTemperatureUnits).toJS();
  const stockHierarchy = useSelector(getStockHierarchy).toJS();
  const productionOptions = useSelector(getProductions).toJS();
  const utensils = useSelector(getUtensils).toJS();
  const shelfLifeTimeUnits = useSelector(getShelfLifeTimeUnitsUnits).toJS();
 
  const ppis = stitchPpis(ppiDataList);
  const ppsi = stichPpsi(data, ppis, ingredientEntries, language,franchiseType);
  

  // Added to remove the excluded ingredients from the overview tab

  let finalPpsi;

  if (ppiDetails === undefined) {
    finalPpsi = ppsi;
  } else {
    const getExcludedItemCodes =
      ppiDetails &&
      ppiDetails.filter(i => i.ppiNotRequired === true).map(i => i.itemCode);

    const ppiWithoutExcludeData =
      ppsi.ppiDetails &&
      ppsi.ppiDetails.filter(i => !getExcludedItemCodes.includes(i.itemCode));
    const sortedPPI = sortBy(ppiWithoutExcludeData, 'ingredient.lineId');
    // const finalList = sortedPPI.filter(function(i){
    //   return i.ppi !== undefined && i.ppi !== null;
    // });
    // finalPpsi = { ...ppsi, ppiDetails: ppiWithoutExcludeData.sort((a, b) => a.ingredient.lineId - b.ingredient.lineId) };
    finalPpsi = { ...ppsi, ppiDetails: sortedPPI };
    // debugger
    // finalPpsi = {
    //   ...ppsi,
    //   ppiDetails: sortedPPI.map((item, index) => ({
    //     ...item,
    //     ingredient: { ...item.ingredient, lineId: index + 1 }
    //   }))
    // };
    // debugger
    // finalPpsi = {
    //   ...ppsi,
    //   ppiDetails: ppiWithoutExcludeData.sort((a, b) => a.ingredient.lineId - b.ingredient.lineId).map((item, index) => ({
    //     ...item,
    //     ingredient: { ...item.ingredient, lineId: index + 1 }
    //   }))
    // };
    // debugger
  }
  return (
    <PPSI
      // debug={true}
      ppsi={{ ...finalPpsi, updateNotificationList: [] } || {}}
      labels={labels}
      timeUnits={timeUnits}
      temperatureUnits={temperatureUnits}
      stockHierarchy={stockHierarchy}
      productionOptions={productionOptions}
      utensils={utensils}
      language={language}
      navigateIcon="none"
      unitSystem={unitSystem}
      shelfLifeTimeUnits={shelfLifeTimeUnits}
    />
  );
};

export default OverviewTabContent;
